if (document.querySelector('#modal-frame')) {
    const html = document.querySelector('html')
    const body = document.querySelector('body')
    const modalFrame = document.querySelector('#modal-frame')
    const modalWindow = document.querySelector('#modal-frame .modal')
    const callModalBtns = document.querySelectorAll('.call-modal-frame')
    const navBar = document.querySelector('nav.navbar')

    let contentType = ''

    callModalBtns.forEach((button) => {
        button.addEventListener('click', function (e) {
            html.classList.add('overflow-hidden')
            body.classList.add('block')
            body.classList.add('block-dark-bg')
            modalFrame.classList.remove('hidden')
            if (button.dataset.contentType) {
                modalWindow.classList.add(button.dataset.contentType)
                contentType = button.dataset.contentType
            }
            navBar.classList.remove('nav-float-show')
            navBar.classList.add('nav-float-hide')

            setTimeout(() => {
                modalWindow.classList.remove('hide')
                modalWindow.classList.add('show')
            }, 200)
        })
    })

    modalFrame.addEventListener('click', (e) => {
        let target = e.target
        if (target == modalFrame || target.closest('.close-modal')) {
            html.classList.remove('overflow-hidden')
            body.classList.remove('block')
            body.classList.remove('block-dark-bg')
            modalWindow.classList.remove('show')
            if (modalWindow.classList.contains(contentType))
                modalWindow.classList.remove(contentType)
            modalWindow.classList.add('hide')
            modalFrame.classList.add('hidden')
        }
    })
}
